export interface Chart {
  title: string;
  namedQueries: string[];
  data: any[];
  chartSeries: any[];
  pieSeries?: any[];
  stats?: string[],
  type?: string;
  order?: number;
}

export const chartsCfg: Chart[] = [
  {
    title: 'National policy on open access publications',
    namedQueries: ['Question6','Question6.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question6','Question6.1'],
    // order: 1
  },
  {
    title: 'Countries with a Specific Policy on Immediate Open Access to Publications',
    namedQueries: ['Question6.3', 'Question6.3.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question6.3', 'Question6.3.1'],
    // order: 1
  },
  {
    title: 'Countries with a Specific Policy on Retention of IPR on Publications',
    namedQueries: ['Question6.4', 'Question6.4.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question6.4','Question6.4.1'],
    // order: 1
  },
  {
    title: 'Countries with a Specific Policy on Open Licensing of Publications',
    namedQueries: ['Question6.5', 'Question6.5.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question6.5', 'Question6.5.1'],
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Open Access to Publications',
    namedQueries: ['Question7'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question7'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Open Access to Publications',
    namedQueries: ['Question54'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question54'],
  },
  {
    title: 'Share of EU Countries with National Investments in Open Access to Publications per 1000 FTE Researchers',
    namedQueries: ['Question56', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question56'],
  },
  {
    title: 'National Policy on Open Access to Publications',
    namedQueries: ['Question6', 'Question6.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question6'],
  },
  {
    title: 'Specific Policy on Immediate Open Access to Publications',
    namedQueries: ['Question6.3', 'Question6.3.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question6.3'],
  },
  {
    title: 'Specific Policy on Retention of IPR on Publications',
    namedQueries: ['Question6.4', 'Question6.4.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question6.4'],
  },
  {
    title: 'Specific Policy on Open Licensing of Publications',
    namedQueries: ['Question6.5', 'Question6.5.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question6.5'],
  },
  {
    title: 'Financial Strategy on Open Access to Publications',
    namedQueries: ['Question7'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question7'],
  },
  {
    title: 'National Monitoring on Open Access to Publications',
    namedQueries: ['Question54'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question54'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Open Access to Publications per 1000 FTE Researchers',
    namedQueries: ['Question56', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question56_trend'],
  },
  {
    title: 'National policy on data management',
    namedQueries: ['Question10','Question10.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question10','Question10.1'],
    // order: 1
  },
  {
    title: 'National policy on FAIR data',
    namedQueries: ['Question14','Question14.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question14','Question14.1'],
    // order: 1
  },
  {
    title: 'National policy on open data',
    namedQueries: ['Question18','Question18.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question18','Question18.1'],
    // order: 1
  },
  {
    title: 'Financial Strategy on data management',
    namedQueries: ['Question11'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question11'],
    // order: 1
  },
  {
    title: 'Financial Strategy on FAIR data',
    namedQueries: ['Question15'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question15'],
    // order: 1
  },
  {
    title: 'Financial Strategy on open data',
    namedQueries: ['Question19'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question19'],
    // order: 1
  },
  {
    title: 'National Monitoring on data management',
    namedQueries: ['Question58'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question58'],
    // order: 1
  },
  {
    title: 'National Monitoring on FAIR data',
    namedQueries: ['Question62'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question62'],
    // order: 1
  },
  {
    title: 'National Monitoring on open data',
    namedQueries: ['Question66'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question66'],
    // order: 1
  },
  {
    title: 'Share of EU Countries with National Investments in Data Management per 1000 FTE Researchers',
    namedQueries: ['Question60', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question60'],
  },
  {
    title: 'Shared of EU Countries with National Investments in FAIR Data per 1000 FTE Researchers',
    namedQueries: ['Question64', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question64'],
  },
  {
    title: 'Share of EU Countries with National Investments in Open Data per 1000 FTE Researchers',
    namedQueries: ['Question68', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question68'],
  },
  {
    title: 'National Policy on Data Management',
    namedQueries: ['Question10', 'Question10.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question10'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on FAIR Data',
    namedQueries: ['Question14', 'Question14.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question14'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Open Data',
    namedQueries: ['Question18', 'Question18.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question18'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Data Management',
    namedQueries: ['Question11'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question11'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on FAIR Data',
    namedQueries: ['Question15'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question15'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Open Data',
    namedQueries: ['Question19'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question19'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Data Management',
    namedQueries: ['Question58'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question58'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on FAIR Data',
    namedQueries: ['Question62'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question62'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Open Data',
    namedQueries: ['Question66'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question66'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Data Management per 1000 FTE Researchers',
    namedQueries: ['Question60', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments', // Type is correct do not change, according to other trends
    stats: ['Question60_trend'],
  },
  {
    title: 'Trend in EU Countries with National Investments in FAIR Data per 1000 FTE Researchers',
    namedQueries: ['Question64', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments', // Type is correct do not change, according to other trends
    stats: ['Question64_trend'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Open Data per 1000 FTE Researchers',
    namedQueries: ['Question68', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments', // Type is correct do not change, according to other trends
    stats: ['Question68_trend'],
  },
  {
    title: 'National Policy on Open Source Software',
    namedQueries: ['Question22','Question22.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question22','Question22.1'],
    // order: 1
  },
  {
    title: 'Financial Strategy on Open Source Software',
    namedQueries: ['Question23'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question23'],
  },
  {
    title: 'National Monitoring on Open Source Software',
    namedQueries: ['Question70'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question70'],
  },
  {
    title: 'Share of EU Countries with National Investments in Open Source Software per 1000 FTE Researchers',
    namedQueries: ['Question72', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question72'],
  },
  {
    title: 'National Policy on Open Source Software',
    namedQueries: ['Question22', 'Question22.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question22'],
  },
  {
    title: 'Trend in Financial Strategy on Open Source Software',
    namedQueries: ['Question23'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question23'],
  },
  {
    title: 'Trend in Countries with a National Monitoring on Open Source Software',
    namedQueries: ['Question70'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question70'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Open Source Software per 1000 FTE Researchers',
    namedQueries: ['Question72', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question72_trend'],
  },
  {
    title: 'Map of EU Countries with a National Policy on Offering Services through EOSC',
    namedQueries: ['Question26', 'Question26.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question26', 'Question26.1'],
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Offering Services through EOSC',
    namedQueries: ['Question27'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question27'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Offering Services through EOSC',
    namedQueries: ['Question74'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question74'],
  },
  {
    title: 'Share of EU Countries with National Investments in Offering Services through EOSC per 1000 FTE Researchers',
    namedQueries: ['Question76', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question76'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Offering Services through EOSC',
    namedQueries: ['Question26', 'Question26.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question26'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Offering Services through EOSC',
    namedQueries: ['Question27'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question27'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Offering Services through EOSC',
    namedQueries: ['Question74'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question74'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Offering Services through EOSC per 1000 FTE Researchers',
    namedQueries: ['Question76', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question76_trend'],
  },
  {
    title: 'Map of EU Countries with a National Policy on Connecting Repositories to EOSC',
    namedQueries: ['Question30','Question30.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question30','Question30.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a National Policy on Data Stewardship',
    namedQueries: ['Question34', 'Question34.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question34', 'Question34.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a National Policy on Long-term Data Preservation',
    namedQueries: ['Question38', 'Question38.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question38', 'Question38.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Connecting Repositories to EOSC',
    namedQueries: ['Question31'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question31'],
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Data Stewardship',
    namedQueries: ['Question35'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question35'],
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Long-term Data Preservation',
    namedQueries: ['Question39'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question39'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Connecting Repositories to EOSC',
    namedQueries: ['Question78'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question78'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Data Stewardship',
    namedQueries: ['Question82'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question82'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Long-term Data Preservation',
    namedQueries: ['Question86'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question86'],
  },
  {
    title: 'Share of EU Countries with National Investments in Connecting Repositories to EOSC per 1000 FTE Researchers',
    namedQueries: ['Question80', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question80'],
  },
  {
    title: 'Share of EU Countries with National Investments in Data Stewardship per 1000 FTE Researchers',
    namedQueries: ['Question84', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question84'],
  },
  {
    title: 'Share of EU Countries with National Investments in Long-term Data Preservation per 1000 FTE Researchers',
    namedQueries: ['Question88', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question88'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Connecting Repositories to EOSC',
    namedQueries: ['Question30', 'Question30.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question30'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Data Stewardship',
    namedQueries: ['Question34', 'Question34.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question34'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Long-term Data Preservation',
    namedQueries: ['Question38', 'Question38.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question38'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Connecting Repositories to EOSC',
    namedQueries: ['Question31'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question31'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Data Stewardship',
    namedQueries: ['Question35'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question35'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Long-term Data Preservation',
    namedQueries: ['Question39'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question39'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Long-term Data Preservation',
    namedQueries: ['Question78'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question78'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Data Stewardship',
    namedQueries: ['Question82'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question82'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Long-term Data Preservation',
    namedQueries: ['Question86'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question86'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Connecting Repositories to EOSC per 1000 FTE Researchers',
     namedQueries: ['Question80', 'Question1'],
     data: [],
     chartSeries: [],
     pieSeries: [],
     type: 'totalInvestments',
     stats: ['Question80_trend'],
   },
  {
    title: 'Trend in EU Countries with National Investments in Data Stewardship per 1000 FTE Researchers',
    namedQueries: ['Question84', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question84_trend'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Long-term Data Preservation per 1000 FTE Researchers',
    namedQueries: ['Question88', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question88_trend'],
  },
  {
    title: 'Map of EU Countries with a National Policy on Skills/training for Open Science',
    namedQueries: ['Question42','Question42.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question42','Question42.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Skills/training for Open Science',
    namedQueries: ['Question43'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question43'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Skills/training for Open Science',
    namedQueries: ['Question90'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question90'],
  },
  {
    title: 'Share of EU Countries with National Investments in Skills/training for Open Science per 1000 FTE Researchers',
    namedQueries: ['Question92', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question92'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Skills/training for Open Science',
    namedQueries: ['Question42', 'Question42.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question42'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Skills/training for Open Science',
    namedQueries: ['Question43'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question43'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Skills/training for Open Science',
    namedQueries: ['Question90'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question90'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Skills/training for Open Science per 1000 FTE Researchers',
    namedQueries: ['Question92', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question92_trend'],
  },
  {
    title: 'Map of EU Countries with a National Policy on Incentives/rewards for Open Science',
    namedQueries: ['Question46','Question46.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question46','Question46.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Incentives/rewards for Open Science',
    namedQueries: ['Question47'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question47'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Incentives/rewards for Open Science',
    namedQueries: ['Question94'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question94'],
  },
  {
    title: 'Share of EU Countries with National Investments in Incentives/rewards for Open Science per 1000 FTE Researchers',
    namedQueries: ['Question96', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question96'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Incentives/rewards for Open Science',
    namedQueries: ['Question46', 'Question46.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question46'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Incentives/rewards for Open Science',
    namedQueries: ['Question47'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question47'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Incentives/rewards for Open Science',
    namedQueries: ['Question94'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question94'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Incentives/rewards for Open Science per 1000 FTE Researchers',
    namedQueries: ['Question96', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question96_trend'],
  },
  {
    title: 'Map of EU Countries with a National Policy on Citizen Science',
    namedQueries: ['Question50','Question50.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question50','Question50.1'],
    // order: 1
  },
  {
    title: 'Map of EU Countries with a Financial Strategy on Citizen Science',
    namedQueries: ['Question51'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question51'],
  },
  {
    title: 'Map of EU Countries with a National Monitoring on Citizen Science',
    namedQueries: ['Question98'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'mapWithPoints',
    stats: ['Question98'],
  },
  {
    title: 'Share of EU Countries with National Investments in Citizen Science per 1000 FTE Researchers',
    namedQueries: ['Question100', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question100'],
  },
  {
    title: 'Trend in EU Countries with a National Policy on Citizen Science',
    namedQueries: ['Question50', 'Question50.1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'stackedBars',
    stats: ['Question50'],
  },
  {
    title: 'Trend in EU Countries with a Financial Strategy on Citizen Science',
    namedQueries: ['Question51'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question51'],
  },
  {
    title: 'Trend in EU Countries with a National Monitoring on Citizen Science',
    namedQueries: ['Question98'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'barChart',
    stats: ['Question98'],
  },
  {
    title: 'Trend in EU Countries with National Investments in Citizen Science per 1000 FTE Researchers',
    namedQueries: ['Question100', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestments',
    stats: ['Question100_trend'],
  },
  {
    title: 'Share of EU Countries with National Investments in EOSC and Open Science in Millions of Euros',
    namedQueries: ['Question5', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'totalInvestmentsRangeColumns',
    stats: ['Question5_total'],
  },
  {
    title: 'Share of EU Countries with National Investments in EOSC and Open Science per 1000 FTE Researchers',
    namedQueries: ['Question5', 'Question1'],
    data: [],
    chartSeries: [],
    pieSeries: [],
    type: 'rangeColumns',
    stats: ['Question5'],
  }
]

// What report_template.docx can reference: the tags below plus the keys of every chart. Keep it in step with
// loadChart and the *Series methods of report-creation.component.ts (the component spec checks them against it);
// `npm run docx:tags:check` reads this file with Node, so it may only use syntax that is erased as is.

/** Text tags that are set whatever the charts. */
export const reportGlobalKeys = ['Year', 'FiscalYear'];

/** Image tags that do not come from a chart (staticImages in generateReport). */
export const staticImageKeys = ['logoImage'];

const indexed = (stat: string, count: number) => Array.from({length: count}, (_, i) => `${stat}[${i}]`);

/** The text tags a chart sets in reportData once it has data. */
export function reportKeys(chart: Chart): string[] {
  const stats = chart.stats ?? [];
  if (stats.length === 0)
    return [];

  switch (chart.type) {
    case 'rangeColumns':
      return [...indexed(stats[0], 7), `${stats[0]}_invested`];
    case 'totalInvestmentsRangeColumns':
      return indexed(stats[0], 7);
    case 'stackedBars':
      return indexed(stats[0], 4);
    case 'barChart':
    case 'totalInvestments':
      return indexed(stats[0], 2);
    default: // a map counts the answers of every stat
      return stats;
  }
}

/** Whether the chart also builds one pie chart per query (pieChartImage_<chart>_<query>), which the others don't. */
export function buildsPies(chart: Chart): boolean {
  return !['rangeColumns', 'totalInvestmentsRangeColumns', 'stackedBars', 'barChart', 'totalInvestments'].includes(chart.type ?? '');
}
